import {Injectable, HostListener} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NavigationEnd, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {TranslateService} from '@ngx-translate/core';

import {HttpBase} from 'app/services/http-base.service';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {ColumnSettingsBase, WebTableSettings} from "../slick-grid/models/column-settings-base";
import {Versions} from "../shared/models/vesions";
import {ModuleTableName} from "../shared/models/module-table-name";
import {SimpleSettings} from "../shared/models/simple-settings";
import {FontSize} from "../shared/models/font-size";
import {b} from "@angular/core/src/render3";
import {LocalizationCorrespondence} from "../shared/models/localization-correspondence";
import {FilterControlSettings} from "../stocks/models/filter-control-settings";

type TableSettingsResponse = { accessDenied: boolean, columns: ColumnSettingsBase[] };

type LocalizationCorrespondenceSettingsResponse = { success: boolean, correspondence: LocalizationCorrespondence[] };

type FontDimensions = { success: boolean, accessDenied: boolean, data: string };

type MultipleTableSettingsResponse = { accessDenied: boolean, tableSettings: WebTableSettings[], settings: { name: string, value: string }[], isAdmin: boolean };

@Injectable()
export class CommonService extends HttpBase{
    constructor(http: HttpClient, router: Router, translateService: TranslateService){
        super(http, router, translateService);
        // console.trace('Create CommonService')
        this.count = 0;
    }

    public count: number;

    private mouseMoveSource = new BehaviorSubject(null);
    mouseMoveCurrent = this.mouseMoveSource.asObservable();

    private pointerMoveSource = new BehaviorSubject(null);
    pointerMoveCurrent = this.pointerMoveSource.asObservable();

    private mouseDownSource = new BehaviorSubject(null);
    mouseDownCurrent = this.mouseDownSource.asObservable();

    getClientName = (): Observable<{ success: boolean, clientName: string }> =>{
        return this.get<{ success: boolean, clientName: string }>('/api/home/GetClientName');
    };

    saveFile = (url): Observable<any> =>{
        return this.get<any>(url, {responseType: 'blob'});
    };

    setMouseMove = (e: MouseEvent): void =>{
        this.count++;
        // console.log(this.count++, 'setMouseMove');
        this.mouseMoveSource.next(e);
    };

    setPointerMove = (e: PointerEvent): void =>{
        // console.log(e, 'setMouseMove');
        this.pointerMoveSource.next(e);
    };

    getMouseMove = (): MouseEvent =>{
        return this.mouseMoveSource.getValue();
    };

    setMouseDown = (e: MouseEvent): void =>{
        this.mouseDownSource.next(e);
    };

    //# get settings for table
    getTableSettings = (module: string, table: string, fresh: number): Observable<TableSettingsResponse> =>{

        return this.get<TableSettingsResponse>('/api/common/gettablesettings', {
            params: {
                module,
                table,
                fresh
            }
        });
    }

    /**
     * get data from localization correspondence settings, for set translates, in tables
     * @param moduleName Name of the module in localization correspondence table
     * @param tableName Name of the table in localization correspondence table
     */
    getLocalizationCorrespondenceSettings = (moduleName: string, tableName: string,): Observable<LocalizationCorrespondenceSettingsResponse> =>{
        return this.get<LocalizationCorrespondenceSettingsResponse>('/api/common/GetLocalizationCorrespondence', {
            params: {
                moduleName,
                tableName
            }
        });
    }

    //# get settings for table
    getFontDimensions = (fontName: string, fontSize: string): Observable<FontDimensions> =>{
        return this.get<FontDimensions>('/api/SlickGridProperties/GetFontDimensions', {params: {
                fontName,
                fontSize
            }
        });
    }

    //# get settings for table
    saveFontDimensions = (fontDimensions: FontSize): Observable<{ success: boolean } > =>{
        return this.post<{ success: boolean }>('/api/SlickGridProperties/SaveFontDimensions', {
            data: JSON.stringify(fontDimensions)
        });
    }

    //# get settings for multiple tables
    getMultipleTableSettings = (tables: ModuleTableName[], settings: string[]): Observable<MultipleTableSettingsResponse> =>{
        return this.post<MultipleTableSettingsResponse>('/api/common/GetMultipleTableSettings', {
            tablesSettings: tables,
            inSettings: settings
        });
    };
    getSettings = (properties: string[]): Observable<{ success: boolean, settings: SimpleSettings[] }> => {
        return this.post<{ success: boolean, settings: SimpleSettings[] }>('/api/common/GetSettings', properties);
    }

    //# get settings for table
    getUserName = (): Observable<{success: boolean, userName: string}> =>{
        return this.get<{success: boolean, userName: string}>('/api/common/GetUserName' );
    }

    //# get settings for table
    getVersionPermission = (moduleName: string, version: string): Observable<{success: boolean, versionNotCompatible: boolean, isAdmin: boolean}> =>{
        return this.get<{success: boolean, versionNotCompatible: boolean, isAdmin: boolean}>('/api/common/GetVersionPermissions', {params: {
                moduleName,
                version
            }
        });
    }

    //# get current date
    getDate = (): Observable<{success: boolean, date: string}> =>{
        return this.get<{success: boolean, date: string}>('/api/common/getdate');
    }

    //# get current date
    getDateTime = (): Observable<{success: boolean, date: string}> =>{
        return this.get<{success: boolean, date: string}>('/api/common/getdatetime');
    }


    getFilterSettings = (moduleName: string): Observable<{ success: boolean, filterSettings: FilterControlSettings[]}> => {
        return this.get<{ success: boolean, filterSettings: FilterControlSettings[]}>('/api/common/GetFilterSettings', {params: {moduleName}});
    }


    /*sendGA = (category: string, label: string, action: string, value: number): void =>{
        (<any>window).ga('send', 'event', {
            eventCategory: category,
            eventLabel: label,
            eventAction: action,
            userName: userName,
            eventValue: value
        });

    };

    registerGA = async (router: Router): Promise<void> => {
        let prop = await this.getSettings(['GoogleAnalyticsID']).toPromise();


        if (prop && prop.success && prop.settings.length){
            await this.getUserName().toPromise().then(res => this.userName = res.success ? res.userName : 'unknown' );
            console.log(this.userName)
            let GAID = prop.settings.filter(item => item.name === 'GoogleAnalyticsID');
            GAID && GAID.length && (<any>window).ga('create', GAID[0].value, 'auto');
            router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    (<any>window).ga('set', 'page', event.urlAfterRedirects);
                    (<any>window).ga('send', 'pageview');
                }
            });
        }
    }

    public userName: string;

    }*/

}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts